import { Alert, CircularProgress } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import TextField from '@mui/material/TextField';
import { Stack } from '@mui/system';
import { doc, setDoc } from 'firebase/firestore';
import { ref, uploadBytes } from 'firebase/storage';
import { FC, Fragment, useState } from 'react';
import { useSelector } from 'react-redux';
import { isStepNotComplete } from '../../common/utils';
import { PersonalTabs, UserProfileStep } from '../../consts/types/user';
import { db, storage } from '../../firebase';
import { UserSelectors } from '../../reducers/user';
const { NotificationManager } = require('react-notifications');



const PersonalTabsLabels = {
    [PersonalTabs.Personal]: "Details",
    [PersonalTabs.Description]: "Description",
    // [PersonalTabs.Salary]: "Work & Salary",
}


interface PersonalDetailsProps {
    currentTab: PersonalTabs;
    onClose: () => void;
}

type Props = PersonalDetailsProps;

const PersonalDetails: FC<Props> = (props: Props) => {
    const user = useSelector(UserSelectors.currentUser);

    const [name, setName] = useState(user?.name || "");
    const [title, setTitle] = useState(user?.title || "");
    const [area, setArea] = useState(user?.area || "");
    const [phone, setPhone] = useState(user?.phone || "");
    const [city, setCity] = useState(user?.city || "");
    const [age, setAge] = useState(user?.age || null);
    const [largeCompanies, setLargeCompanies] = useState(user?.largeCompanies || false);
    const [management, setManagement] = useState(user?.management || false);
    const [startup, setStartup] = useState(user?.startup || false);
    const [car, setCar] = useState(user?.management || false);
    const [notifyOnAllJobs, setNotifyOnAllJobs] = useState(user?.notifyOnAllJobs || false);
    const [description, setDescription] = useState(user?.description || "");
    const [salary, setSalary] = useState(user?.salary || "");
    const [isSaving, setIsSaving] = useState(false);
    const [isSavingDescription, setIsSavingDescription] = useState(false);
    const [isSavingSalary, setIsSavingSalary] = useState(false);
    const [largeCompaniesDocument, setLargeCompaniesDocument] = useState<File | null>(null);
    const [startupDocument, setStartupDocument] = useState<File | null>(null);
    const [managementDocument, setManagementDocument] = useState<File | null>(null);
    const [tab, setTab] = useState(props.currentTab);

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setTab(newValue);
    };

    const save = () => {
        if (user?.email && name && phone) {
            setIsSaving(true);
            setDoc(doc(db, "users", user.email), {
                name,
                title,
                phone,
                city,
                area,
                age,
                notifyOnAllJobs,
                car
            }, { merge: true })
                .then(() => {
                    setIsSaving(false);
                    props.onClose();
                    NotificationManager.success('Changes were saved successfully!',);
                })
                .catch(() => {
                    setIsSaving(false);
                    NotificationManager.error('Something went wrong. Please try again.',);
                });
        }

    }
    // const isShowAlert = () => {
    //     return (user?.largeCompanies && !user.largeCompaniesDocument) ||
    //         (user?.startup && !user.startupDocument) ||
    //         (user?.management && !user.managementDocument);
    // }

    const generalInfoChange = (generalInfo: Record<string, any>) => {
        if (user?.email) {
            const isGeneral = generalInfo.general;
            if (isGeneral) {
                setIsSavingSalary(true);
                generalInfo = { largeCompanies, startup, management, salary, largeCompaniesDocument: "", startupDocument: "", managementDocument: "" };
                if (largeCompaniesDocument) {
                    generalInfo.largeCompaniesDocument = largeCompaniesDocument.name;
                }
                if (startupDocument) {
                    generalInfo.startupDocument = startupDocument.name;
                }
                if (managementDocument) {
                    generalInfo.managementDocument = managementDocument.name;
                }
            }
            else if (generalInfo.description) {
                setIsSavingDescription(true);
            }
            setDoc(doc(db, "users", user.email), {
                ...generalInfo,
            }, { merge: true })
                .then(() => {
                    props.onClose();
                    NotificationManager.success("Changes were saved successfully!");
                    if (largeCompaniesDocument) {
                        const storageRef = ref(storage, `${user.email}/largeCompaniesDocument__${largeCompaniesDocument.name}`);
                        uploadBytes(storageRef, largeCompaniesDocument)
                            .then(() => {
                                setIsSavingDescription(false);
                                setIsSavingSalary(false);

                            })
                            .catch(() => {
                                setIsSavingDescription(false);
                                setIsSavingSalary(false);

                            });
                    }
                    if (startupDocument) {
                        const storageRef = ref(storage, `${user.email}/startupDocument__${startupDocument.name}`);
                        uploadBytes(storageRef, startupDocument)
                            .then(() => {
                                setIsSavingDescription(false);
                                setIsSavingSalary(false);

                            })
                            .catch(() => {
                                setIsSavingDescription(false);
                                setIsSavingSalary(false);

                            });
                    }
                    if (managementDocument) {
                        const storageRef = ref(storage, `${user.email}/managementDocument__${managementDocument.name}`);
                        uploadBytes(storageRef, managementDocument)
                            .then(() => {
                                setIsSavingDescription(false);
                                setIsSavingSalary(false);

                            })
                            .catch(() => {
                                setIsSavingDescription(false);
                                setIsSavingSalary(false);

                            });
                    }
                    if (!isGeneral || (!largeCompaniesDocument && !startupDocument && !managementDocument)) {
                        setIsSavingDescription(false);
                        setIsSavingSalary(false);

                    }
                })
                .catch(() => {
                    setIsSavingDescription(false);
                    setIsSavingSalary(false);

                    NotificationManager.error('Something went wrong. Please try again.',);
                });
        }
    }

    return <Fragment>
        {/* {isShowAlert() && <Alert severity='warning' sx={{ mb: { xs: 2, md: 1 } }} >Verifying documents are missing. Please make sure to attach the relevant documents in order to gain a higher matching score.</Alert>} */}
        <Stack spacing={3} pb={{ xs: 1, md: 3 }} maxWidth="100%">
            {isStepNotComplete(UserProfileStep.PersonalDetails) && <Alert severity='warning' sx={{ display: { xs: "flex", md: "none" }, mb: 1 }}>Step is not completed yet</Alert>}
            <Tabs value={tab} onChange={handleTabChange} variant="scrollable" scrollButtons="auto">
                {Object.entries(PersonalTabs).filter(([key, value]) => isNaN(Number(key))).map(([key, value]) => <Tab key={key} label={PersonalTabsLabels[value as PersonalTabs]}
                    value={value} />)}
            </Tabs>
            {tab === PersonalTabs.Personal && <Box mb={2}>
                <FormGroup>
                    <TextField value={user?.email} label="Email" size="small" disabled />
                    <Stack direction={{ xs: "column", md: "row" }} justifyContent="space-between" gap={3} my={3}>
                        <TextField value={name} onChange={e => setName(e.target.value)} label="Name" size="small" fullWidth required />
                    </Stack>
                    <Stack direction={{ xs: "column", md: "row" }} justifyContent="space-between" gap={3} mb={3}>
                        <TextField value={title} onChange={e => setTitle(e.target.value)} label="Title" size="small" fullWidth placeholder='Fullstack Developer' />
                    </Stack>
                    <Stack direction={{ xs: "column", md: "row" }} justifyContent="space-between" gap={3} mb={3}>

                        <TextField value={phone} onChange={e => setPhone(e.target.value)} label="Phone Number" size="small" fullWidth required />
                        <TextField type="number" value={age} onChange={e => setAge(Number(e.target.value))} label="Age" size="small" fullWidth />
                    </Stack>
                    <Stack direction={{ xs: "column", md: "row" }} justifyContent="space-between" gap={3} mb={3}>
                        <TextField value={city} onChange={e => setCity(e.target.value)} label="City" fullWidth size="small" />
                        <FormControl fullWidth size="small">
                            <InputLabel >Area</InputLabel>
                            <Select label="Area"
                                value={area}
                                onChange={(e) => { setArea(e.target.value as string) }}
                            >
                                <MenuItem value={"Tel Aviv"} >Tel Aviv</MenuItem>
                                <MenuItem value={"Jerusalem"} >Jerusalem</MenuItem>
                                <MenuItem value={"Haifa"}>Haifa</MenuItem>
                                <MenuItem value={"North"} >North</MenuItem>
                                <MenuItem value={"Be`er Sheva"} >Be`er Sheva</MenuItem>
                                <MenuItem value={"South"} >South</MenuItem>
                            </Select>
                        </FormControl>
                    </Stack>
                    {/* <Typography fontSize={{ xs: "0.95rem", md: "1rem" }} mt={2}>General Information</Typography> */}
                    {/* <FormGroup>
                        <FormControlLabel sx={{ mb: 2, mt:2 }}
                            control={
                                <Switch checked={car} onChange={(e) => { setCar(e.target.checked) }} />
                            }
                            label={<Typography fontSize={{xs:"0.9rem", md:"0.95rem"}}>I have a car</Typography>}
                        />
                        <FormControlLabel
                            control={
                                <Switch checked={notifyOnAllJobs} onChange={(e) => { setNotifyOnAllJobs(e.target.checked) }} name="jason" />
                            }
                            label={<Typography fontSize={{xs:"0.9rem", md:"0.95rem"}}>Notify me about jobs from all areas</Typography>}
                        />
                    </FormGroup> */}
                </FormGroup>
                <Box display="flex" justifyContent={{ xs: "center", md: "flex-end" }} mt={3}>
                    <Button onClick={props.onClose} sx={{ mr: 2 }}>Cancel</Button>
                    <Button variant="outlined" disabled={isSaving}
                        // sx={{ backgroundColor: "#0f4687", color: "white", "&:hover": { backgroundColor: "#1d6bca" } }}
                        onClick={save}>
                        {isSaving && <CircularProgress sx={{ width: "18px !important", height: "18px !important", mr: 1, color: "inherit" }} />}
                        SAVE
                    </Button>
                </Box>
            </Box>
            }
            {
                tab === PersonalTabs.Description && <Box mb={2}>
                    <TextField multiline fullWidth
                        value={description}
                        onChange={(e) => { setDescription(e.target.value) }}
                        minRows={5}
                        variant="outlined"
                        label="Description"
                        placeholder="Special things about yourself"
                    />
                    <Box display="flex" justifyContent={{ xs: "center", md: "flex-end" }} mt={3}>
                        <Button onClick={props.onClose} sx={{ mr: 2 }}>Cancel</Button>
                        <Button variant="outlined" disabled={isSavingDescription}
                            // sx={{ backgroundColor: "#0f4687", color: "white", "&:hover": { backgroundColor: "#1d6bca" } }}
                            onClick={() => { generalInfoChange({ description }) }}>
                            {isSavingDescription && <CircularProgress sx={{ width: "18px !important", height: "18px !important", mr: 1, color: "inherit" }} />}
                            SAVE
                        </Button>
                    </Box>
                </Box>
            }





        </Stack >
    </Fragment >;
}


export default PersonalDetails;

